import { DateTime } from "luxon";

type EvDateType = string | object | Date;

export function toLuxonDateTime(value: EvDateType): DateTime {
  if (value instanceof Date) return DateTime.fromJSDate(value);
  if (typeof value === "string") return DateTime.fromISO(value);

  // Fallback for object-like values (e.g., dayjs, moment, or custom date object)
  return DateTime.fromJSDate(value as Date);
}

export function validateEventUpdate({
  newEvStart,
  newEvEnd,
  oldEvStart,
  oldEvEnd
}: {
  newEvStart: EvDateType;
  newEvEnd: EvDateType;
  oldEvStart: EvDateType;
  oldEvEnd: EvDateType;
}): boolean {
  const newStart = toLuxonDateTime(newEvStart);
  const newEnd = toLuxonDateTime(newEvEnd);
  const oldStart = toLuxonDateTime(oldEvStart);
  const oldEnd = toLuxonDateTime(oldEvEnd);

  // Day + time unchanged check
  if (newStart.toISO() === oldStart.toISO() && newEnd.toISO() === oldEnd.toISO()) {
    return false;
  }

  return true; // ✅ safe to continue
}
